<template>
  <div v-if="isMounted" :key="route" class="loader bg-white pt-10 p-10" style="border-radius: 5px">
    <vs-row vs-w="12" class="pb-10">
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12">
        <span style="font-size: 18px; color: black; font-weight: bold">{{
          getProjectSelected.projectName
        }}</span>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="8" vs-sm="4" vs-xs="12">
        <div class="vx-row items-center justify-center" style="font-size: 30px; color: black; font-weight: bold">
          CONTRACTOR DASHBOARD
        </div>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12">
        <span style="font-size: 14px; color: black; font-weight: bold; text-align: right">Last Updated:<br />
          {{ lastUpdate }}</span>
      </vs-col>
    </vs-row>
    <!-- NH3 -->
    <!-- NH3 -->
    <!-- NH3 -->
    <!-- loop through the allData -->


    <vs-row v-for="(value, index) in allData" >
      <vs-col vs-lg="2" vs-sm="2" vs-xs="12" vs-type="flex" vs-justify="end" vs-align="center">
        <div class="vx-row items-end justify-end">
          <h3>{{ index }} [{{ value['totalJoints'] }}]</h3>
        </div>
      </vs-col>
      <vs-col vs-lg="10" vs-sm="10" vs-xs="12" vs-type="flex" vs-justify="center" vs-align="center">
        <div class="vx-row items-center justify-center">

          <template v-for="(fName, fIndex) in value">
            <radialChart :index="fIndex" :settings="fName"></radialChart>
          </template>
        </div>
      </vs-col>
    </vs-row>
    <!-- UREA -->
  </div>
</template>

<script>
// import AdvanceTable from "./advance_table.vue";

import { mapGetters } from "vuex";

import { alertMixin } from "../../mixin/alertMixin";
import { axiosMixin } from "../../mixin/axiosMixin";
import { helperMixin } from "../../mixin/helperMixin";
import { dbSettingsMixin } from "./dbSettingsMixin";

import statistics from "../../components/aron/dashboard_items/statistics/statistics.vue";
import statisticsiconright from "../../components/aron/dashboard_items/statistics/statisticsIconRight.vue";
import horizontalBarChart from "../../components/aron/dashboard_items/chart/horizontalBarChart.vue";
import pieChart from "../../components/aron/dashboard_items/chart/pieChart.vue";
import barChart from "../../components/aron/dashboard_items/chart/barChart.vue";
import radialChart from "../../components/aron/dashboard_items/chart/radialChartContractor.vue";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";

export default {
  components: {
    statistics,
    pieChart,
    barChart,
    statisticsiconright,
    horizontalBarChart,
    radialChart,
    StatisticsCardLine,
  },
  mixins: [dbSettingsMixin, alertMixin, axiosMixin, helperMixin],
  watch: {
    $route(to, from) {
      this.route = this.$route.params.subject;
      this.currentView = "list"; //reset the view
    },
  },
  methods: {},
  data() {
    return {
      reloadMarker: true,
      route: "detailDashboard",
      isMounted: false,
      currentView: "list",
      dataReady: false,
      settings: {},
      lastUpdate: "",
      allData: {},
      totalJoints: 0,
      plantArea: {},
      openJointCount: [],
      boxUpJointCount: [],
      CompletedJointCount: [],
      titleSelected: "OVERALL",
      defaultSelected: "OVERALL",
      eisDbDataNh3: {},
      eisDbDataUREA: {},
      eisDbDataUtility: {},
      tempData: {},
      tempDataurea: {},
      nh3TotalJoints: 0,
      ureaTotalJOints: 0,
      utilityTotalJoints: 0,
    };
  },
  computed: {
    ...mapGetters({
      getUserInfo: "auth/getUserInfo",
      getProjectSelected: "auth/getProjectSelected",
    }),
  },
  methods: {
    startLoading(id) {
      console.log("loading ID:", id);
      this.$vs.loading({
        container: "." + id,
        scale: 0.6,
      });
    },
    stopLoading(id) {
      this.$vs.loading.close("." + id + " > .con-vs-loading");
    },

    getData() {
      // this.startLoading("loader");
      this.addToObject(this.settings.filter, {
        projectId: this.getProjectSelected.id,
      });
      console.log("settings:", this.settings);

      //

      this.aronPost(this.settings.endPoint, this.settings.filter, "", "")
        .then((response) => {
          console.log("response:", response);
          if (response.data.status == "true") {
            console.log("contractor data:", response);
            this.reloadMarker = this.reloadMarker ? false : true;

            this.allData = response.data.values;


            //processing NH3
            // this.updateItemInObject(
            //   this.settings.dataNh3,
            //   "dataName",
            //   "value",
            //   response.data.values["NH3"]
            // );
            // this.addToObject(this.eisDbDataNh3, this.settings.dataNh3);
            // this.nh3TotalJoints = response.data.values["NH3"]["totalJoints"];


            this.lastUpdate = response.data.dateTime;
            this.dataReady = true;
            this.isMounted = true;
          } else {
            this.errorAlert("Error", response.data.error);
          }

          // this.stopLoading("loader");
        })
        .catch((error) => {
          console.log("error:", error);
          this.stopLoading("loader");
        });
    },
  },
  created() {
    this.dataReady = false;
  },
  mounted() {
    this.settings = this.getDashboard("contractor");
    console.log("this.settings in main:", this.settings);

    this.getData();
  },
};
</script>
